import { connect } from 'react-redux';
import Terms from './Terms';


let mapStateToProps = (state) => {
  return {
    shopName: state.aboutPage.aboutData.shopName,
    domain: state.aboutPage.aboutData.domain,
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const TermsContainer = connect(mapStateToProps, mapDispatchToProps)(Terms);

export default TermsContainer;